import { createContext, useState } from "react";

const AuthContext = createContext({});


export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
        name: "",
        id: 0,
        status: true,
      });
    const [Loading, setLoading] = useState(false);
      console.log("AuthProvider mounted");
    return (
        <AuthContext.Provider value={{ auth, setAuth, setLoading, Loading }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
